import Parse from '@/parse'
const Tourism = Parse.Object.extend('Tourism')
const messages = {
  new: '観光ポイントを作成しました。',
  update: '観光ポイントを更新しました。'
}

export default {
  initForm ({ state, commit }) {
    commit('setName', state.tourism.get('name'))
    commit('setUrl', state.tourism.get('url'))
    commit('setDescription', state.tourism.get('description'))
    const location = state.tourism.get('location')
    if (location) {
      commit('setLat', location.latitude)
      commit('setLng', location.longitude)
    } else {
      commit('setLat', 0)
      commit('setLng', 0)
    }
    commit('setRadius', state.tourism.get('radius') * 1000)
  },

  resetForm ({ commit }) {
    commit('setName', '')
    commit('setUrl', '')
    commit('setDescription', '')
    commit('setLat', 0.0)
    commit('setLng', 0.0)
    commit('setRadius', 0)
  },

  retrieveTourisms ({ commit }) {
    let query = new Parse.Query(Tourism)
    query.descending('createdAt')
    query.find().then((results) => {
      commit('setTourisms', results)
    }).catch((error) => {
      console.log(error)
    })
  },

  async getTourism ({ commit }, id) {
    let query = new Parse.Query(Tourism)
    try {
      let object = await query.get(id)
      commit('setTourism', object)
    } catch (error) {
      console.log(error)
    }
  },

  async saveTourism ({ state, dispatch }, action) {
    let tourism = state.tourism
    if (action === 'new') {
      tourism = new Tourism()
    }

    tourism.set('name', state.name)
    tourism.set('url', state.url)
    tourism.set('description', state.description)
    if (state.lat !== 0 && state.lng !== 0) {
      const location = new Parse.GeoPoint(
        state.lat,
        state.lng
      )
      tourism.set('location', location)
    }
    tourism.set('radius', parseFloat(state.radius) / 1000)

    try {
      await tourism.save()
      return messages[action]
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  },

  deleteTourism({ state, commit }) {
    state.tourism.destroy().then(() => {
      commit(
        'snackBar/addMessage',
        '観光ポイントを削除しました。',
        { root: true }
      )
    })
  }
}
